import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import JobPage from "./JobPage";
import JobEditPage from "./JobPage/editPage";
import JobPageGeneralSetting from "./JobPageGeneralSetting";
import JobPageGeneralSettingEditPage from "./JobPageGeneralSetting/editPage";

export default function JobPages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/position`}
        component={withPermission(
          JobPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/general-settings`}
        component={withPermission(
          JobPageGeneralSetting,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />

      <Route
        path={`${match.url}/position/:id`}
        component={withPermission(
          JobEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/general-settings/:id`}
        component={withPermission(
          JobPageGeneralSettingEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
